<template>
    <v-content :style="{'background-image': `url('`+ require('../assets/bg-login.jpg') +`')`}"
               style="background-size: cover">
        <v-layout justify-center class="register-form">
            <v-flex xs12 sm9 md4 mb-12>
                <div class="form-register-alert-error" v-if="regisError">
                    <v-layout class="mt-12 py-2 alert-error">
                        <v-flex>
                            <v-flex ml-4 style="position: absolute">
                                <v-icon style="color: #fff; text-align: left">error_outline</v-icon>
                            </v-flex>
                            *ท่านไม่สามารถลงทะเบียนได้?
                        </v-flex>
                    </v-layout>
                </div>
                <v-card flat class="pa-7 mb-4 regis-card border-bottom-form"
                        :class="{'mt-12': !regisError, 'mb-4': !regisError, 'border-top-form': !regisError}">
                    <!--register error-->
                    <v-layout justify-center v-if="regisError">
                        <v-flex xs4>
                            <img alt="Vue logo" src="../assets/logo.png" style="width: 60%">
                        </v-flex>
                    </v-layout>
                    <v-layout column v-if="regisError">
                        <v-flex shrink class="mb-6 text-color">
                            ลงทะเบียน
                        </v-flex>
                        <v-flex>
                            <v-layout justify-center>
                                <v-flex xs12 md12 style="font-size: 16px; color: #C03939">
                                    *กรุณาติดต่อกรมการแพทย์ทหารบก <u style="font-size: 20px;"><br/>เบอร์ 02-7634492 หรือ 94492 หรือ 02-3544420 ต่อ 106</u>
                                </v-flex>
                            </v-layout>
                        </v-flex>
                    </v-layout>
                    <!--End-->
                    <v-layout justify-center v-if="!regisError">
                        <v-flex xs4>
                            <img alt="Vue logo" src="../assets/logo.png" style="width: 100%">
                        </v-flex>
                    </v-layout>
                    <v-layout column v-if="!regisError">
                        <v-flex shrink class="text-color">
                            ลงชื่อเข้าใช้งาน
                        </v-flex>
                        <v-flex my-2>
                            <v-layout justify-center>
                                <v-flex xs6 sm5 md7>
                                    <div style="border-top: solid 2px #527281; width: 100%; box-shadow: 0 3px 3px rgba(0,0,0,.25)"></div>
                                </v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex shrink>
                            ฐานข้อมูลกลาง
                        </v-flex>
                        <v-flex shrink>
                            คุณลักษณะเฉพาะสิ่งอุปกรณ์สายแพทย์
                        </v-flex>
                    </v-layout>
                    <v-layout justify-center mt-4>
                        <v-flex xs12>
                            <v-flex :class="{'register-form-error':regisError}">
                                <v-form ref="form" lazy-validation>
                                    <div class="text-field-register">
                                        <v-row>
                                            <v-col>
                                                <v-text-field :class="{'custom-placeholer-color' : regisError}"
                                                              dark
                                                              v-model="form.fname"
                                                              :background-color="!regisError ? '#527281' : 'rgba(192, 57, 57, 0.1)'"
                                                              :placeholder="!regisError ? 'ชื่อ' : '*ชื่อ'"
                                                              height="10"
                                                              solo
                                                              :rules="fnameRules"
                                                              required>
                                                </v-text-field>
                                            </v-col>
                                            <v-col>
                                                <v-text-field :class="{'custom-placeholer-color' : regisError}"
                                                              dark
                                                              v-model="form.lname"
                                                              :background-color="!regisError ? '#527281' : 'rgba(192, 57, 57, 0.1)'"
                                                              :placeholder="!regisError ? 'สกุล' : '*สกุล'"
                                                              height="10"
                                                              solo
                                                              :rules="lnameRules"
                                                              required>
                                                </v-text-field>
                                            </v-col>
                                        </v-row>

                                        <v-text-field :class="{'custom-placeholer-color' : regisError}"
                                                      dark
                                                      v-model="form.email"
                                                      :background-color="!regisError ? '#527281' : 'rgba(192, 57, 57, 0.1)'"
                                                      :placeholder="!regisError ? 'อีเมล' : '*อีเมล'"
                                                      height="10"
                                                      solo
                                                      :rules="emailRules"
                                                      required>
                                        </v-text-field>
                                        <v-text-field :class="{'custom-placeholer-color' : regisError}"
                                                      dark
                                                      v-model="form.number"
                                                      :background-color="!regisError ? '#527281' : 'rgba(192, 57, 57, 0.1)'"
                                                      :placeholder="!regisError ? 'หมายเลขโทรศัพท์' : '*หมายเลขโทรศัพท์'"
                                                      height="10"
                                                      type="number"
                                                      solo
                                                      min="0"
                                                      :rules="numberRules"
                                                      required>
                                        </v-text-field>
                                        <v-text-field :class="{'custom-placeholer-color' : regisError}"
                                                      dark
                                                      v-model="form.number_organize"
                                                      :background-color="!regisError ? '#527281' : 'rgba(192, 57, 57, 0.1)'"
                                                      :placeholder="!regisError ? 'หมายเลขโทรศัพท์กองทัพภาค' : '*หมายเลขโทรศัพท์กองทัพภาค'"
                                                      height="10"
                                                      type="number"
                                                      solo
                                                      min="0"
                                                      :rules="numberRules"
                                                      required>
                                        </v-text-field>
                                        <v-select :class="{'custom-placeholer-color' : regisError}"
                                                  :menu-props="{ bottom: true, offsetY: true }"
                                                  v-model="form.department"
                                                  :items="organitzation"
                                                  item-text="organization_name"
                                                  item-value="organization_id"
                                                  dark
                                                  :background-color="!regisError ? '#527281' : 'rgba(192, 57, 57, 0.1)'"
                                                  :label="!regisError ? 'กองทัพภาค' : '*กองทัพภาค'"
                                                  height="10"
                                                  solo
                                                  :rules="dapartmentRules"
                                                  required>
                                        </v-select>
                                        <v-text-field class="mt-6" :class="{'custom-placeholer-color' : regisError}"
                                                      dark
                                                      v-model="form.password"
                                                      type="password"
                                                      :background-color="!regisError ? '#527281' : 'rgba(192, 57, 57, 0.1)'"
                                                      :placeholder="!regisError ? 'รหัสผ่าน' : '*รหัสผ่าน'"
                                                      height="10"
                                                      solo
                                                      :rules="passwordRules"
                                                      required>
                                        </v-text-field>
                                        <v-text-field :class="{'custom-placeholer-color' : regisError}"
                                                      dark
                                                      v-model="form.confirm_Password"
                                                      type="password"
                                                      :background-color="!regisError ? '#527281' : 'rgba(192, 57, 57, 0.1)'"
                                                      :placeholder="!regisError ? 'ยืนยันรหัสผ่าน' : '*ยืนยันรหัสผ่าน'"
                                                      height="10"
                                                      solo
                                                      :rules="ConfirmPasswordRules"
                                                      required>
                                        </v-text-field>
                                    </div>
                                </v-form>
                            </v-flex>

                        </v-flex>
                    </v-layout>
                </v-card>
                <v-layout justify-center>
                    <v-flex xs12>
                        <v-btn style="border-radius: 30px; width: 150px; background-color: #527281; color: #fff"
                               class="ma-2 md6" @click="submit">ลงทะเบียน
                        </v-btn>
                    </v-flex>
                </v-layout>
            </v-flex>
        </v-layout>


        <Footer></Footer>
    </v-content>
</template>

<script>
    import validate from "../utils/validate";
    import Footer from '@/components/Footer.vue'

    export default {
        name: "Register",

        components: {
            Footer,
        },

        computed: {
        },

        created() {
            this.getOrganizationAll()
        },
        data: () => ({
            organitzation: [],
            form: {
                fname: "",
                lname: "",
                email: "",
                number: "",
                number_organize: "",
                department: "",
                password: "",
                confirm_Password: "",
            },
            checkbox: false,
            formHasErrors: false,
            regisError: false,
            fnameRules: [
                v => validate.required(v, "fname"),
            ],
            lnameRules: [
                v => validate.required(v, "lname"),
            ],
            emailRules: [
                v => validate.validEmail(v, "email"),
                v => validate.required(v, "email"),
            ],
            numberRules: [
                v => validate.onlyNumber(v, "number"),
                v => validate.required(v, "number"),
            ],
            dapartmentRules: [
                v => validate.required(v, "department"),
            ],
            passwordRules: [
                v => validate.required(v, "password"),
            ],
            ConfirmPasswordRules: [
                v => validate.required(v, "confirm_Password"),
            ],
        }),
        methods: {
            getOrganizationAll() {
                this.$store.dispatch('Common/getOrganizationAll').then(res => {
                    res.forEach(dataOrganitzation => {
                        this.organitzation.push({
                            organization_id: `${dataOrganitzation.id}`,
                            organization_name: `${dataOrganitzation.name}`
                        });
                    })
                })
            },

            submit() {
                this.$store.dispatch('Auth/register', {
                    firstname: this.form.fname,
                    lastname: this.form.lname,
                    email: this.form.email,
                    tel: this.form.number,
                    tel_organization: this.form.number_organize,
                    organization_id: this.form.department,
                    username: this.form.email,
                    password: this.form.password,
                    c_password: this.form.confirm_Password,
                })
                    .then(data => {
                        alert('สมัครสมาชิกเรียบร้อย')
                        alert('รอการอนุมัติไม่เกิน 3 วันทำการ หรือติดต่อ 02-7634492 หรือ 94492 หรือ 02-3544420 ต่อ 106')
                        this.$router.push({
                            name:"login"
                        });
                    })
                    .catch(err => {
                        this.regisError = true;
                    })


            }
        }
    }
</script>

<style lang="scss">
    .register-form {
        .regis-card {
            background: rgba(255, 255, 255, .18) !important;
        }

        .border-top-form {
            border-top-left-radius: 20px;
            border-top-right-radius: 20px;
        }

        .border-bottom-form {
            border-bottom-left-radius: 20px;
            border-bottom-right-radius: 20px;
        }
    }

    .form-register-alert-error {
        .alert-error {
            /*background: rgba(255,255,255,.01);*/
            font-size: 16px;
            border-top-left-radius: 20px;
            border-top-right-radius: 20px;
            background-color: #C03939;
            color: white;
        }
    }

    .text-field-register {
        .v-text-field.v-text-field--solo .v-input__control {
            min-height: 35px !important;
        }

        .v-input__slot {
            margin-bottom: 0px !important;
        }

        .v-text-field.v-text-field--enclosed .v-text-field__details {
            margin-bottom: 0px;
        }

        .v-text-field--outlined .v-input__control, .v-text-field--outlined .v-input__slot, .v-text-field--outlined fieldset, .v-text-field--solo .v-input__control, .v-text-field--solo .v-input__slot, .v-text-field--solo fieldset {
            border-radius: 12px;
        }

        .form-register-alert-error {
            .alert-error {
                /*background: rgba(255,255,255,.01);*/
                font-size: 16px;
                border-top-left-radius: 20px;
                border-top-right-radius: 20px;
                background-color: #C03939;
                color: white;
            }
        }
    }

    .register-form-error {
        .custom-placeholer-color input::placeholder {
            color: #C03939 !important;
            opacity: 1;
        }

        .v-icon.v-icon {
            color: #C03939;
            opacity: 1;
        }

        .v-text-field.v-text-field--solo:not(.v-text-field--solo-flat) > .v-input__control > .v-input__slot {
            border-style: solid !important;
            border-color: #C03939 !important;
            border-width: 1px;
        }

        .theme--dark {
            color: #C03939 !important;
        }

        .theme--dark.v-input:not(.v-input--is-disabled) input, .theme--dark.v-input:not(.v-input--is-disabled) textarea {
            color: #000000 !important;
        }

        .theme--dark.v-select .v-select__selections, .theme--light.v-select.v-text-field--solo-inverted.v-input--is-focused .v-select__selections {
            color: #000000 !important;
        }
    }

</style>
